import { useEffect, useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
export default function About() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const values = [
    {
      icon: 'ri-hand-heart-line',
      title: 'Trust',
      description: 'Building lasting relationships through integrity and transparency in every transaction.',
    },
    {
      icon: 'ri-star-line',
      title: 'Quality',
      description: 'Uncompromising standards in materials, manufacturing, and final product inspection.',
    },
    {
      icon: 'ri-leaf-line',
      title: 'Sustainability',
      description: 'Eco-friendly practices and durable products that serve generations.',
    },
    {
      icon: 'ri-heart-line',
      title: 'Indian Values',
      description: 'Rooted in traditional craftsmanship and commitment to community welfare.',
    },
  ];
  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      <section className="relative h-80 sm:h-[60vh] w-full overflow-hidden mt-20">
        <picture>
          <source media="(max-width: 768px)" srcSet="/assets/About-mobile.jpg" />
          <img
            src="/assets/About.jpg"
            alt="Our Heritage"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
        </picture>
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
        <div className="relative h-full flex items-center justify-center">
          <div className="text-center px-4 sm:px-6">
            <div className="mb-4 inline-block">
              <div className="border-t-2 border-b-2 border-amber-400 py-2 px-4 sm:px-6">
                <span className="text-amber-300 text-xs sm:text-sm font-medium tracking-widest uppercase">
                  Our Story
                </span>
              </div>
            </div>
            <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold text-white mb-4 leading-tight">
              Our Roots. Our Responsibility.
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-white/90 max-w-2xl mx-auto">
              A legacy of trust, quality, and traditional Indian craftsmanship
            </p>
          </div>
        </div>
      </section>
      <section className="py-16 sm:py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 md:gap-16 items-center">
            <div className="order-2 lg:order-1">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-amber-900 mb-4 sm:mb-6 md:mb-8">
                Serving India Since 2025
              </h2>
              <p className="text-gray-700 mb-4 sm:mb-6 leading-relaxed text-base sm:text-lg">
                Akshayraj Industry Pvt. Ltd. was founded in the heart of Ujjain, Madhya Pradesh,
                with a vision to provide every Indian household with safe and reliable water storage
                solutions. What started as a small manufacturing unit has grown into a trusted name
                across India.
              </p>
              <p className="text-gray-700 mb-4 sm:mb-6 leading-relaxed text-base sm:text-lg">
                Our journey is deeply rooted in traditional Indian values of honesty, quality, and
                community service. We believe that access to clean water is not just a business—it's
                a responsibility we carry with pride.
              </p>
              <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
                Today, we manufacture premium water tanks and milk cans using advanced PUF insulation
                technology while maintaining the craftsmanship and attention to detail that has been
                our hallmark for decades.
              </p>
            </div>
            <div className="order-1 lg:order-2 flex justify-center lg:justify-end">
              <div className="relative w-full max-w-md lg:max-w-none">
                <img
                  src="/assets/AboutC.png"
                  alt="Traditional Craftsmanship"
                  className="w-full h-96 sm:h-[500px] md:h-[600px] object-cover rounded-2xl shadow-2xl border-2 border-amber-100 group-hover:border-amber-400 transition-colors duration-300"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 sm:py-20 md:py-28 bg-gradient-to-b from-amber-50/30 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12 sm:mb-16 md:mb-20">
            <span className="text-amber-600 font-semibold text-xs sm:text-sm tracking-widest uppercase">
              What Drives Us
            </span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-amber-900 mt-3 sm:mt-4 mb-3 sm:mb-4 md:mb-6">
              Our Core Values
            </h2>
            <p className="text-gray-700 max-w-2xl mx-auto text-base sm:text-lg">
              These principles guide every decision we make and every product we manufacture
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="group bg-white p-6 sm:p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-amber-100 hover:border-amber-400 hover:-translate-y-2 cursor-pointer"
              >
                <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-gradient-to-br from-amber-100 to-amber-50 rounded-xl mx-auto mb-4 shadow-md group-hover:shadow-lg transition-all duration-300">
                  <i className={`${value.icon} text-3xl sm:text-4xl text-amber-900 group-hover:text-amber-700 transition-colors`}></i>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-amber-900 mb-2 sm:mb-3 text-center group-hover:text-amber-700 transition-colors">{value.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed text-center">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}